import React, { useState, useRef } from 'react';
import './Player.css'

const Player = (props) => {
const [isPlaying, setIsPlaying] = useState(false);
const videoRef = useRef(null);

const togglePlay = () => {
    if (isPlaying) {
        videoRef.current.pause();
    } else {
        videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
};

return (
    <div className='topo'>
        
        <div className='envolve'>
                <button onClick={togglePlay} className={`btn duration-200 ease-in-out ${isPlaying ? "translate-y-[35vh] bg-blue10D-light opacity-50 " : "bg-blue10D "}"}`}
                >
                    {isPlaying ? "Pause" : "Play"}
                </button>
                <div className='video' >
                    <video
                        ref={videoRef}
                    >
                        <source src={props.src} type="video/mp4"/>
                    </video>
                </div>
                
                
        </div>
    </div>
)}

export default Player;
/*
controls
width="100%"
height="100%"

<div className='video' >
                    <video
                        ref={videoRef}
                        
                    >
                        <source src={props.src} type="video/mp4"/>
                    </video>
</div>

*/